import React from 'react'
import { strings } from '@constants'
import {
	TableCard,
	ProductsCardHeader,
	ProductsTitleGroup,
	ProductsTitle,
	TableHeaderRow,
	TableHeaderCell,
	TableRow,
	TableCell,
	SkeletonBlock,
} from './styles'

const SKELETON_ROW_COUNT = 5

// Mirrors SimpleProductTable/TmtProductTable's real markup (same TableCard/TableHeaderRow/TableRow
// structure, real column headers) with skeleton blocks standing in for the search input and each
// row's inputs — kept as one shared component since both tables render an identical shape, just
// with different column flex ratios and weight/price header labels.
const ProductItemsSkeleton = ({ columnFlex, weightLabel, priceLabel }) => (
	<TableCard>
		<ProductsCardHeader>
			<ProductsTitleGroup>
				<ProductsTitle>{strings('product_name')}</ProductsTitle>
			</ProductsTitleGroup>
			<SkeletonBlock $width='14rem' />
		</ProductsCardHeader>
		<TableHeaderRow>
			<TableHeaderCell flex={columnFlex.name}>{strings('product', 'name')}</TableHeaderCell>
			<TableHeaderCell flex={columnFlex.grade}>{strings('grade')}</TableHeaderCell>
			<TableHeaderCell flex={columnFlex.weight}>{weightLabel}</TableHeaderCell>
			<TableHeaderCell flex={columnFlex.price}>{priceLabel}</TableHeaderCell>
			<TableHeaderCell flex={columnFlex.action} align='center'>
				{strings('action')}
			</TableHeaderCell>
		</TableHeaderRow>
		{Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
			<TableRow key={index}>
				<TableCell flex={columnFlex.name}>
					<SkeletonBlock />
				</TableCell>
				<TableCell flex={columnFlex.grade}>
					<SkeletonBlock />
				</TableCell>
				<TableCell flex={columnFlex.weight}>
					<SkeletonBlock />
				</TableCell>
				<TableCell flex={columnFlex.price}>
					<SkeletonBlock />
				</TableCell>
				<TableCell flex={columnFlex.action} align='center'>
					<SkeletonBlock $width='1.5rem' $height='1.5rem' />
				</TableCell>
			</TableRow>
		))}
	</TableCard>
)

export default React.memo(ProductItemsSkeleton)
